// Action Types
export const FETCH_CLIENT_NUDGE_REQUEST = "FETCH_CLIENT_NUDGE_REQUEST";
export const FETCH_CLIENT_NUDGE_SUCCESS = "FETCH_CLIENT_NUDGE_SUCCESS";
export const FETCH_CLIENT_NUDGE_FAILURE = "FETCH_CLIENT_NUDGE_FAILURE";

// Action Creators
export const fetchClientNudgeRequest = (data) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_CLIENT_NUDGE_REQUEST,
      payload: data,
    });
  };
};
export const fetchClientNudgeSuccess = (data) => ({
  type: FETCH_CLIENT_NUDGE_SUCCESS,
  payload: data,
});
export const fetchClientNudgeFailure = (error) => ({
  type: FETCH_CLIENT_NUDGE_FAILURE,
  payload: error,
});
